import { connect } from "react-redux";
import actionCreators from "../redux/actionCreators";
import { getProjectId, getTab } from "../redux/selectors";
import SidebarMenuTabs from "./sidebarMenuTabs";
const mapStateToProps = (state) => ({
    projectId: getProjectId(state),
    tabKey: getTab(state)
});
const mapDispatchToProps = (dispatch) => ({
    onChangeTab: (tabKey) => dispatch(actionCreators.setTab(tabKey))
});
export default connect(mapStateToProps, mapDispatchToProps)(SidebarMenuTabs);
